import request from '@/utils/request'

// 详情页查询回款计划列表
export function listContractPlanFund(query) {
  return request({
    url: '/crmContractPlanFund/listNoPage',
    method: 'get',
    params: query
  })
}

// 分页查询回款计划列表
export function listPageContractPlanFund(query) {
  return request({
    url: '/crmContractPlanFund/list',
    method: 'post',
    data: query
  })
}
export function queryContractPlanFundInfo(data) {
  return request({
    url: '/crmContractPlanFund/queryContractPlanFundInfo',
    method: 'post',
    data: data
  })
}

// 查询回款计划详情
export function queryContractPlanFundDetail(query) {
  return request({
    url: '/crmContractPlanFund/detail',
    method: 'get',
    params: query
  })
}

// 新增回款计划
export function createContractPlanFund(data) {
  return request({
    url: '/crmContractPlanFund/create',
    method: 'post',
    data: data
  })
}

// 更新回款计划
export function updateContractPlanFund(data) {
  return request({
    url: '/crmContractPlanFund/update',
    method: 'post',
    data: data
  })
}

// 删除回款计划
export function delContractPlanFund(data) {
  return request({
    url: '/crmContractPlanFund/delete',
    method: 'post',
    data: data
  })
}
